import * as React from 'react'
import { View } from 'components/View'
import getStyleComponentUtil from 'modules/component/utils/get-style'

export default function SurfaceFilter ({
  height = 2,
  bgc,
  style,
  bdr,
  ...rest
}) {
  return (
    <View
      {...rest}
      bdr={bdr}
      style={getStyleComponentUtil({
        '-webkit-filter': 'drop-shadow( 0px 2px 3px rgba(0, 0, 0, .5))',
        filter: 'drop-shadow( 0px 2px 3px rgba(0, 0, 0, .5))'
      }, style)}
    />
  )
}
